import { useEffect, useState } from 'react';
import './App.css';
import Animation from './components/Animation';
import Information from './components/Information';
import { db } from './firebase';
import { collection, onSnapshot } from "firebase/firestore";

function App() {
  const [details, setDetails] = useState([])
  useEffect(() => {
    onSnapshot(collection(db, "farid"), (snapshot) => {
      setDetails(snapshot.docs.map(doc => doc.data()))
      // console.log(snapshot)
    })
  }, [])

  console.log(details[0])
  return (
    <section className="main">
      <Animation />
      <Information detail={details[0]} />
    </section>
  );
}

export default App;
